var selectors = {
  galleryDeskScroller: $('[data-gallery-scroller]'),
  galleryDeskScrollerBtns: $('[data-gallery-new-scroll-button]'),
  galleryDeskScrollerBtnUp: $('[data-gallery-new-scroll-button].scroll-up'),
  galleryDeskScrollerBtnDown: $('[data-gallery-new-scroll-button].scroll-down'),
  galleryThumb: $('[data-gallery-thumbnail'),
  galleryVideoThumb: $('.product-gallery--video-thumbnail'),
  stickyChooseColor: $('.stickyAddToCart--color-name'),
  stickyChooseColorContent: $('.stickyAddToCart--detail .custom-field'),
  stickyChooseSize: $('.stickyAddToCart--detail .option-header'),
  stickyChooseSizeContent: $('.stickyAddToCart--detail .option-values'),
  filterButton: $('[data-filter-button]'),
  filterCategoryButton: $('[data-category-filter-button]'),
  atcBtn: $('.stickyAddToCart--atc-btn')
}

if ($( window ).width() >= 720) {
  handleScrollButtonVisibility();
}

selectors.galleryDeskScrollerBtns.on('click', function(e) {
  if ($(this).hasClass('scroll-up')) {
    onScrollButtonClick(true);
  } else if ($(this).hasClass('scroll-down')) {
    onScrollButtonClick(false);
  }
});

selectors.galleryDeskScroller.on('scroll', function(e) {
  handleScrollButtonVisibility();
});

selectors.galleryThumb.on('click', function(e) {
  if ($( window ).width() >= 720) {
    
  }
});

selectors.galleryVideoThumb.on('click', function(e) {
  if ($( window ).width() < 720) {
    setTimeout(function() {
      $('.plyr__video-wrapper video')[0].play();
    }, 400)
  }
});

var lastScrollTop = 0;
if ($('.product-form--atc').length > 0) {
  $(window).on('scroll', function() {
    let atcBtnPosition = $('.product-form--atc').position().top + 120;
    var st = $(this).scrollTop();
    
    if (st < lastScrollTop) {
      if (st > atcBtnPosition) {
        $('.stickyAddToCart--container').addClass('shown');
      } else {
        $('.stickyAddToCart--container').removeClass('shown');
        selectors.stickyChooseColorContent.removeClass('in');
        selectors.stickyChooseSizeContent.removeClass('in');
      }
    } else { // Scrolling downwards
      if (st > atcBtnPosition) {
        $('.stickyAddToCart--container').addClass('shown');
      } else {
        $('.stickyAddToCart--container').removeClass('shown');
        selectors.stickyChooseColorContent.removeClass('in');
        selectors.stickyChooseSizeContent.removeClass('in');
      }
    }
    
    lastScrollTop = st;
  });
}


selectors.stickyChooseColor.on('click', function() {
  selectors.stickyChooseSize.removeClass('active');
  if (!$(this).hasClass('active')) {
    selectors.stickyChooseColorContent.addClass('in');
    selectors.stickyChooseSizeContent.removeClass('in');
    $(this).addClass('active');
  } else {
    selectors.stickyChooseColorContent.removeClass('in');
    $(this).removeClass('active');
  }
});

selectors.stickyChooseSize.on('click', function() {
  selectors.stickyChooseColor.removeClass('active');
  if (!$(this).hasClass('active')) {
    selectors.stickyChooseSizeContent.addClass('in');
    selectors.stickyChooseColorContent.removeClass('in');
    $(this).addClass('active');
  } else {
    selectors.stickyChooseSizeContent.removeClass('in');
    $(this).removeClass('active');
  }
});

selectors.atcBtn.on('click', function(e) {
  e.preventDefault();
  if (this.querySelector('.stickyAddToCart--atc-button').disabled) {
    if (!selectors.stickyChooseSize.hasClass('active')) {
      selectors.stickyChooseSizeContent.addClass('in');
      selectors.stickyChooseColorContent.removeClass('in');
      selectors.stickyChooseSize.addClass('active');
    } else {
      selectors.stickyChooseSizeContent.removeClass('in');
      selectors.stickyChooseSize.removeClass('active');
    }
  } else {
    $('.stickyAddToCart--footer form').submit();
  }
});

$('body').on('click', function() {
  selectors.stickyChooseSizeContent.removeClass('in');
  selectors.stickyChooseColorContent.removeClass('in');
  selectors.stickyChooseSize.removeClass('active');
  selectors.stickyChooseColor.removeClass('active');
});

$('.stickyAddToCart--detail .option-header, .stickyAddToCart--color-name, .stickyAddToCart--detail .option-values, .stickyAddToCart--detail .custom-field, .stickyAddToCart--atc-btn').on('click', function(e) {
  if(!$(this).hasClass('stickyAddToCart--atc-btn')) {
    e.stopPropagation();
  } else if($(this).find('.stickyAddToCart--atc-button').is(":disabled")) {
    e.stopPropagation();
  }
});

var sizeInputs = document.querySelectorAll('[data-product-form-area] input[type="radio"]');
var select = document.querySelector('.stickyAddToCart--detail select[name="id"]');
sizeInputs.forEach(function(element) {
  let size = element.value;
  // element.addEventListener('click', function(evt) {
  //   let sizeInput = document.querySelector('.stickyAddToCart input.option-value-input[value="'+size+'"]');
  //   sizeInput.checked = true;
  //   var opts = select.options;
  //   for (var opt, i = 0; opt = opts[i]; i++) {
  //     if (opt.getAttribute('data-variant-title') == size) {
  //       select.selectedIndex = i;
  //       break;
  //     }
  //   }
  // });
});

selectors.filterButton.on('click', function(e) {
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
    $('.product-filters-section').hide();
  } else {
    $(this).addClass('active')
    $('.product-filters-section').show();
    selectors.filterCategoryButton.removeClass('active');
    $('.product-category-section').hide();
  }
});

selectors.filterCategoryButton.on('click', function(e) {
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
    $('.product-category-section').hide();
  } else {
    $(this).addClass('active')
    $('.product-category-section').show();
    selectors.filterButton.removeClass('active');
    $('.product-filters-section').hide();
  }
});

function handleScrollButtonVisibility() {
  if ($( window ).width() >= 720) {
    if (selectors.galleryDeskScroller.scrollTop() + selectors.galleryDeskScroller.outerHeight() >= selectors.galleryDeskScroller.prop('scrollHeight') - 1) {
      selectors.galleryDeskScrollerBtnDown.removeClass('visible');
    } else {
      selectors.galleryDeskScrollerBtnDown.addClass('visible');
    }

    if (selectors.galleryDeskScroller.scrollTop() + selectors.galleryDeskScroller.height() == selectors.galleryDeskScroller.height()) {
      selectors.galleryDeskScrollerBtnUp.removeClass('visible');
    } else {
      selectors.galleryDeskScrollerBtnUp.addClass('visible');
    }
  } else {
    selectors.galleryDeskScrollerBtnUp.removeClass('visible');
    selectors.galleryDeskScrollerBtnDown.removeClass('visible');
  }
}
function onScrollButtonClick(scrollUp) {
  if (scrollUp) {
    selectors.galleryDeskScroller.animate({
      scrollTop: selectors.galleryDeskScroller.scrollTop() - 150
    });
  } else {
    selectors.galleryDeskScroller.animate({
      scrollTop: selectors.galleryDeskScroller.scrollTop() + 150
    });
  }
}
// PI-REMOVE-JS
// var col_carousel = $('.nav-collection-container-carousel').flickity({
//   cellAlign: 'left',
//   prevNextButtons: false,
//   pageDots: false
// });
// var collection_slider = $('.mobile-navsubmenu-collection-carousel').flickity({
//   cellAlign: 'left',
//   prevNextButtons: false,
//   pageDots: false
// });


$('.navmenu-link-main').on('click', function(e) {
  e.preventDefault();
  $('.navmenu-link-main').removeClass('active');
  $(this).addClass('active');
  let menu = $(this).data('menu');
  $('.mobile-navsubmenu-parent').removeClass('active');
  $('.mobile-navmenu-'+menu).addClass('active');
  $('.nav-collection-container').removeClass('hidden');
  $('.navmenu-depth-2').removeClass('hidden');
  $('.mobile-navsubmenu-child').removeClass('active');
  $('.mobile-nav-ad-block').show();
  col_carousel.flickity('resize');
})
$('.mobile-navmenu-return').on('click', function(e) {
  e.preventDefault();
  $(this).parent().removeClass('active');
  let parent = $(this).data('parent');
  $('.mobile-navmenu-'+parent+' > ul.navmenu-submenu').removeClass('hidden');
  $('.nav-collection-container-'+parent).removeClass('hidden');
  $('.mobile-nav-ad-block').show();
  col_carousel.flickity('resize');
})
$('.mobile-navsubmenu > .navmenu-submenu').on('click', '.mobile-navmenu-toggle', function(e) {
  e.preventDefault();
  let child = $(this).data('nav-child');
  $('.mobile-navsubmenu-child').removeClass('active');
  $('.mobile-navsubmenu-'+child).addClass('active');
  $(this).parents('ul.navmenu-submenu').addClass('hidden');
  $('.nav-collection-container').addClass('hidden');
  $('.mobile-nav-ad-block').hide();
  collection_slider.flickity('resize');
})
$('[data-menu-toggle]').on('click', function(){
  col_carousel.flickity('resize');
  collection_slider.flickity('resize');
});

// UPSELL PRODUCT SCRIPT
document.addEventListener('click', function(e) {
  if(e.target.classList.contains('upsellProduct__modal')) {
    document.querySelector('.upsellProduct__modal').classList.remove('active');
    $('.product-main').css('z-index', 1);
    $('.site-main').css('z-index', 1);
  }
});
var flickOptions = {
  cellAlign: 'center',
  contain: true,
  prevNextButtons: false
}
var upsellFlick = $('.upsellProduct__modal-product-images').flickity(flickOptions);
$('.upsellProduct__close-modal').on('click', function() {
  $('.upsellProduct__modal').removeClass('active');
  $('.product-main').css('z-index', 1);
  $('.site-main').css('z-index', 1);
});
$('.upsellProduct__details, .upsellProduct__img, .upsellProduct__title').on('click', function(e) {
  e.preventDefault();
  $('.upsellProduct__modal').addClass('active');
  $('.product-main').css('z-index', 502);
  $('.site-main').css('z-index', 999);
  upsellFlick.flickity('destroy');
  upsellFlick.flickity(flickOptions);
});
$('.upsellProduct').on('click', function(e) {
  if (!(e.target.classList.contains('upsellProduct__details') || e.target.classList.contains('upsellProduct__img-img') || e.target.classList.contains('upsellProduct__title'))) {
    $(this).toggleClass('active');
    if ($(this).hasClass('active')) {
      $('.upsellProduct__modal-btns').addClass('added');
    } else {
      $('.upsellProduct__modal-btns').removeClass('added');
    }
  }
});
$('.upsellProduct__btn-add').on('click', function(e) {
  e.preventDefault();
  $('.upsellProduct__modal').removeClass('active');
  $('.upsellProduct__modal-btns').addClass('added');
  $('.upsellProduct').addClass('active');
  $('.product-main').css('z-index', 1);
  $('.site-main').css('z-index', 1);
});
$('.upsellProduct__btn-remove').on('click', function(e) {
  e.preventDefault();
  $('.upsellProduct__modal').removeClass('active');
  $('.upsellProduct__modal-btns').removeClass('added');
  $('.upsellProduct').removeClass('active');
  $('.product-main').css('z-index', 1);
  $('.site-main').css('z-index', 1);
});
$('.upsellProduct__btn-added').on('click', function(e) {
  e.preventDefault();
});
$('[data-product-form]').on('change', '.option-value-input', function() {
  $('.upsellProduct').addClass('enabled');
});
if($('[data-product-form] .option-value-input:checked').length > 0) {
  $('.upsellProduct').addClass('enabled');
}



$( document ).ready(function() {
  
  //alert(document.domain);
  
  var dom = document.domain;
  
  if(dom == 'ca.nisolo.com')
  {
    document.getElementById("can").classList.remove("flag_none"); 
  }
  
   if(dom == 'uk.nisolo.com')
  {
    document.getElementById("uk").classList.remove("flag_none");
  }
});

$( document ).ready(function() {
  
//   alert(document.domain);
  
  var dom = document.domain;
  
  if(dom != 'nisolo.com')
  {
   var ele1 = $("#shipping p");
    ele1.css("display", "none");
    
   var ele1 = $("div#talkable-offer");
    ele1.css("display", "none");

   var ele1 = $("div#shopify-section-template--15719322779829__97fc0b93-3086-4e90-a267-317da9db6f81");
    ele1.css("display", "none");
  
   var ele2 = $(".free-shipping-text");
    ele2.css("display", "none");
     
   var ele2 = $("li.navmenu-item.navmenu-item-parent.navmenu-id-ethical-marketplace");
    ele2.css("display", "none");
    
   var ele2 = $(".site-footer-block-content.rte.usa");
    ele2.css("display", "none");
    
   var ele1 = $("li.navmenu-item.navmenu-id-ethical-marketplace");
    ele1.css("display", "none");
  
   var ele1 = $("div#shopify-section-template--15719322779829__e3daa9bb-c79a-44e2-b16f-2c77f69ac3fc");
    ele1.css("display", "none");
    
     var ele1 = $(".klaviyo.usa");
    ele1.css("display", "none");

   var ele1 = $(".usa-only");
    ele1.css("display", "none");
  }
});

$( document ).ready(function() {
  
  // console.log('Domain', document.domain);
  
  var dom = document.domain;
  
  if(dom == 'nisolo.com')
  {

  
   var ele1 = $(".site-footer-block-content.rte.international");
    ele1.css("display", "none");

    var ele1 = $(".international");
    ele1.css("display", "none");
    
    var ele1 = $(".klaviyo.international");
    ele1.css("display", "none");
    document.querySelector('.counddown_banner.show_on_usa_domain').style.display = 'flex';
  }
});

  document.addEventListener("DOMContentLoaded", (event) => {
    var announcementUs = document.querySelector('.announcement_us');
    var announcementInternational = document.querySelector('.announcement_international');
    
    var currentUrl = window.location.href;
    var url = new URL(currentUrl);
    var domain = url.hostname;
    
    if(domain == 'nisolo.com'){
      announcementUs.classList.add('active');
      announcementInternational.classList.remove('active');
    }else {
      announcementUs.classList.remove('active');
      announcementInternational.classList.add('active');
    }
  });
$( document ).ready(function() { 
  var dom = document.domain;
  if(dom != 'nisolo.com'){
   document.querySelector('.counddown_banner.show_on_international_domains').style.display = 'flex';
   $('fieldset.size_radios .option-value span').each(function(e) {
      let s= $(this).html();
     // console.log(s);
     $(this).html(`US<br>${s}`);
    })
    
  }
});
document.addEventListener("DOMContentLoaded", (event) => {
$('.product-single__media').each(function(){
  $(this).click(function(event) {
    const id = $(this).data('media-id');
    $('.custom_image_gallary_main').css('display','block');
    $('.slider_thumbs_div').each(function(){
         const med_id =  $(this).data('media-id');
        if(med_id == id){
          $(this).click();
        }
      });
      $('.site-header-wrapper').css('z-index','1');
      $('#qab_placeholder').css('position','relative');
      $('#qab_placeholder').css('z-index','1');
    });
  });
  $('.custom_image_gallary_main button.close').click(function(event) {
      $('.custom_image_gallary_main').css('display','none');
      $('.site-header-wrapper').css('z-index','700');
      $('#qab_placeholder').css('position','relative');
      $('#qab_placeholder').css('z-index','700');
  });
});
document.addEventListener('DOMContentLoaded',()=>{
 const swatches =  document.querySelectorAll('.color_swatches_custom .color_swatches_img img');
 if(swatches.length > 0){
 const prev_handle = document.querySelector('.color_swatches_custom .color_swatches_img').dataset.handle;
 const label = document.querySelector('.color_swatches_main .color_swatch_label');
  document.querySelectorAll('.color_swatches_custom .color_swatches_img').forEach((item)=>{
  item.addEventListener('mouseenter',(event)=>{
    const handle = item.dataset.handle;
    label.textContent = handle;
    label.classList.add('opacity_state');
  })
 }) 
  document.querySelectorAll('.color_swatches_custom .color_swatches_img').forEach((item)=>{
  item.addEventListener('mouseleave',(event)=>{
    label.textContent = prev_handle;
    label.classList.remove('opacity_state');  

  })
})
 }
// PI-REMOVE-JS
//  if (window.innerWidth < 768) {
//   $('.variant_options').flickity({
//     wrapAround: false,
//     cellAlign: 'left',
//     pageDots: false,
//     contain: true
//   });
//   $('.scrollable-container').slick({
//     dots: true,
//     infinite: false,
//     speed: 300,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//   });
   
//  if(swatches.length > 5){
//   $('.color_swatches_custom_slider').flickity({
//     wrapAround: false,
//     cellAlign: 'left',
//     pageDots: false,
//     contain: true
//   });
//  }
//   }
const joinBtn = document.querySelector('#BIS_trigger');
const addToCart = document.querySelector('.main_product_btn');
const stickyBtn = document.querySelector('.sticky_add_to_cart');
const form = document.querySelector('.color_swatches_main');
let fieldSet = Array.from(document.querySelectorAll('.variant_options .variant_option'));
  
  stickyBtn.addEventListener('click',()=>{
    let error_response = document.querySelector('.error_response');
    let value = fieldSet.find((field)=>{
      return field.querySelector('input:checked');
    })
     
    form.scrollIntoView({
      behavior: 'smooth', // Add smooth scrolling effect
      block: 'start', // Scroll to the top of the element
    });
    if (value === undefined) {
      error_response.style.display = 'block';
      return;
    }else error_response.style.display = 'none';
    
  })


let options = {
  rootMargin: "0px",
  threshold: 1.0,
};

let observer = new IntersectionObserver(callback, options);

function callback(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // `addToCart` is in view
      stickyBtn.style.display = 'none';
    } else {
      // `addToCart` is out of view
      stickyBtn.style.display = 'block';
    }
  });
}

observer.observe(addToCart);
  
document.querySelectorAll('.variant_option input').forEach((e)=>{
    const size_addional = document.querySelector('.selectedSize .size_addional');
    const size = document.querySelector('.selectedSize #size')
    const error_response = document.querySelector('.error_response');
    const input = document.querySelector('input[name="id"]');
    const klaviyo = document.querySelector('.klaviyo-bis-trigger.link_trigger');
    const submit_btn = document.querySelector('.product-form--atc button[data-product-atc]');
    const BIS_trigger = document.querySelector('a#BIS_trigger');
    const upsellProduct = document.querySelector('.upsellProduct');
    const sticky_add_to_info_btn = document.querySelector('.sticky_add_to_info button');
    e.addEventListener('change',(e)=>{
      const quantity = parseInt(e.target.dataset.quantity);
      if(error_response){
        error_response.style.display = 'none';
        document.querySelector('span.size_addionall').style.display = 'flex';
      }
      const variant = e.target.value;
      if(variant){
        history.replaceState(null, null, `?variant=${variant}`);
      }
      const value = e.target.dataset.value;
      if(size){
        size.textContent = 'Size ' + value;
      }
      if(input){
        input.value = e.target.value;
      }
      const isSoldOut = e.target.hasAttribute('sold-out');
      //console.log(e.target);
      if(isSoldOut){
        if(size_addional){
          size_addional.style.display = 'block';
          size_addional.textContent = '(Out of Stock)';
          size_addional.style.color = '#DE733D';
        }
        if(klaviyo) klaviyo.classList.add('link_trigger_active');
        if(BIS_trigger) BIS_trigger.style.display = 'block';
        if(submit_btn) submit_btn.classList.add('disabled'); 
        if(upsellProduct) upsellProduct.classList.remove('enabled');
        if(sticky_add_to_info_btn) sticky_add_to_info_btn.textContent = 'JOIN WAITLIST';
      }else{
        if(size_addional && quantity <= 24){
           size_addional.style.display = 'block';
           size_addional.textContent = `(Only ${quantity} left in stock)`;
           size_addional.style.color = '#666';
        }else if(size_addional) size_addional.style.display = 'none';
        if(klaviyo) klaviyo.classList.remove('link_trigger_active');
        if(BIS_trigger) BIS_trigger.style.display = 'none';
        if(submit_btn) submit_btn.classList.remove('disabled'); 
        if(upsellProduct) upsellProduct.classList.add('enabled');
        if(sticky_add_to_info_btn) sticky_add_to_info_btn.textContent = 'ADD TO CART';
      }
      if (e.target.hasAttribute('preorder')) {
        size_addional.style.display = 'none';
      }
    })
  })

 
 const scrollingDiv = document.querySelector('.main_product_btn');
  const accodianMobile = document.querySelector('.product_description_details');
  let scrollThreshold = 400;
  let isFixed = false;
  const windowHeight = window.innerHeight;

  //console.log(`Window Height: ${windowHeight}px`);

  const accodianRect = accodianMobile.getBoundingClientRect();
  
  if (accodianRect.bottom > 0 && accodianRect.top < window.innerHeight) {
    isFixed = true;
    //alert(true);
  } else {
    isFixed = false;
    //alert(false);
  }
  
  if (windowHeight <= 1100 && !isFixed) {
    scrollingDiv.classList.add('sticky');
    if (windowHeight > 700) {
      scrollThreshold = 250;
    } else {
      scrollThreshold = 400;
    }
    //console.log('scrollThreshold:' + scrollThreshold);

    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY || window.pageYOffset;

      if (scrollPosition > scrollThreshold) {
        scrollingDiv.classList.remove('sticky');
      } else if (scrollPosition <= scrollThreshold) {
        scrollingDiv.classList.add('sticky');
      }
    });
  }  
})

 document.addEventListener('DOMContentLoaded', () => {
  var header = document.querySelector('header.site-header');
  var newheader = document.querySelector('.site-header-wrapper');
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.id === 'yotpo-star-rating-reviews-summary') {
            node.addEventListener('click', function() {
                header.classList.add('active');
                newheader.classList.add('active');
            });
          }
        });
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Event delegation to handle click on dynamically added hideDrop element
  document.addEventListener('click', function(event) {
    if (event.target && event.target.classList.contains('yotpo-reviews-summary-modal-backdrop')) {
      header.classList.remove('active');
      newheader.classList.remove('active');
    }
    if (event.target && event.target.classList.contains('yotpo-close-icon')) {
      header.classList.remove('active');
      newheader.classList.remove('active');
    }
  });
});


// Quick Add to Cart function that can be used on any page. works with snippets/quick-add-variant

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('quick-add-modal');
  const modalBody = document.getElementById('quick-add-body');
  const closeBtn = document.getElementById('quick-add-close');

  document.querySelectorAll('.quick-add-btn').forEach(button => {
    button.addEventListener('click', async (e) => {
      e.preventDefault( );
      const handle = button.dataset.handle;
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();
      buildQuickAddForm(product);
      modal.classList.add('show');
    });
  });

  closeBtn.addEventListener('click', () => {
    modal.classList.remove('show');
    modalBody.innerHTML = '';
  });

  function buildQuickAddForm(product) {
    const firstVariant = product.variants[0];

    modalBody.innerHTML = `
      <div style="display: flex; gap: 16px; align-items: center;">
        <img src="${product.images[0]}" alt="${product.title}" style="width: 80px; height: auto; border-radius: 6px; object-fit: cover;" />
        <div style="flex: 1;">
          <h2 style="margin: 0 0 4px;">${product.title}</h2>
          <div id="quick-add-price" style="font-weight: bold;">${formatMoney(firstVariant.price)}</div>
          <div id="quick-add-stock" style="margin: 4px 0;">${getStockStatus(firstVariant)}</div>
        </div>
      </div>

      <form id="quick-add-form" style="margin-top: 16px;">
        ${buildOptionSelectors(product)}

        <label style="display: block; margin: 12px 0 4px;">Quantity</label>
        <input type="number" id="quick-add-qty" name="quantity" min="1" value="1" style="width: 100%; padding: 8px; border-radius: 4px; border: 1px solid #ccc;" />

        <input type="hidden" name="id" id="variant-id" value="${firstVariant.id}" />
        <button type="submit" style="margin-top: 16px; width: 100%; padding: 10px; background: black; color: white; border: none; border-radius: 4px; cursor: pointer;" ${firstVariant.available ? '' : 'disabled'}>
          Add to Cart
        </button>
        <div id="quick-add-feedback" style="margin-top: 10px; color: green; display: none;">Added to cart!</div>
      </form>
    `;

    // Select first available options
    product.options.forEach((_, index) => {
      const group = modalBody.querySelector(`.option-group[data-option-index="${index}"]`);
      const firstEnabled = group.querySelector('.option-button:not([disabled])');
      if (firstEnabled) firstEnabled.classList.add('selected');
    });

    updateVariant(product);

    modalBody.querySelectorAll('.option-button').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const group = button.closest('.option-group');
        group.querySelectorAll('.option-button').forEach(b => b.classList.remove('selected'));
        button.classList.add('selected');
        updateVariant(product);
      });
    });

    document.getElementById('quick-add-form').addEventListener('submit', addToCart);
  }

  function buildOptionSelectors(product) {
    return product.options.map((option, optionIndex) => {
      const values = [...new Set(product.variants.map(v => v.options[optionIndex]))];

      return `
        <div class="option-group" data-option-index="${optionIndex}" style="margin: 12px 0;">
          <div style="margin-bottom: 4px; font-weight: bold;">${option.name}</div>
          <div class="option-values">
            ${values.map(value => {
              const matchingVariants = product.variants.filter(v => v.options[optionIndex] === value);
              const availableVariant = matchingVariants.find(v => v.available);
              const disabled = !availableVariant;

              let badge = '';
              if (availableVariant && availableVariant.inventory_quantity < 5 && availableVariant.inventory_management === 'shopify') {
                badge = `<span class="low-stock-badge">Low</span>`;
              }

              return `
                <div style="position: relative;">
                  <button
                    class="option-button"
                    data-value="${value}"
                    data-option-index="${optionIndex}"
                    ${disabled ? 'disabled' : ''}
                  >${value}</button>
                  ${badge}
                </div>
              `;
            }).join('')}
          </div>
        </div>
      `;
    }).join('');
  }

  function updateVariant(product) {
    const selections = [];
    product.options.forEach((_, i) => {
      const selectedBtn = modalBody.querySelector(`.option-group[data-option-index="${i}"] .option-button.selected`);
      selections.push(selectedBtn ? selectedBtn.dataset.value : null);
    });

    const match = product.variants.find(v =>
      v.options.every((opt, i) => opt === selections[i])
    );

    const priceEl = document.getElementById('quick-add-price');
    const stockEl = document.getElementById('quick-add-stock');
    const variantIdInput = document.getElementById('variant-id');
    const submitBtn = modalBody.querySelector('button[type="submit"]');

    if (match) {
      variantIdInput.value = match.id;
      priceEl.textContent = formatMoney(match.price);
      stockEl.innerHTML = getStockStatus(match);
      submitBtn.disabled = !match.available;
    } else {
      stockEl.innerHTML = `<span style="color: gray;">Select available options</span>`;
      submitBtn.disabled = true;
    }
  }

  async function addToCart(e) {
    e.preventDefault();
    const variantId = document.getElementById('variant-id').value;
    const quantity = parseInt(document.getElementById('quick-add-qty').value, 10) || 1;
    const feedback = document.getElementById('quick-add-feedback');

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });

    if (res.ok) {
      feedback.style.display = 'block';
      setTimeout(() => {
        feedback.style.display = 'none';
        modal.classList.remove('show');
        modalBody.innerHTML = '';
      }, 1500);
      window.location.reload()
    }
  }

  function formatMoney(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }

  function getStockStatus(variant) {
    if (!variant.available) {
      return `<span style="color: red;">Sold out</span>`;
    }
    if (variant.inventory_management === 'shopify' && variant.inventory_quantity !== null) {
      if (variant.inventory_quantity < 5) {
        return `<span style="color: orange;">Only ${variant.inventory_quantity} left!</span>`;
      } else {
        return `<span style="color: green;">In stock</span>`;
      }
    }
    return `<span style="color: green;">In stock</span>`;
  }
});
// END QUICK ADD